// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\r\nbutton.MuiTab-root {\r\n\tbackground-color: white;\r\n\tborder-right: 1px solid #e0e0e0;\r\n}", "",{"version":3,"sources":["webpack://./src/js/page/Home.css"],"names":[],"mappings":";AACA;CACC,uBAAuB;CACvB,+BAA+B;AAChC","sourcesContent":["\r\nbutton.MuiTab-root {\r\n\tbackground-color: white;\r\n\tborder-right: 1px solid #e0e0e0;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
